import { appConfig } from '../../../config/customization';

const content = {
  minHeight: 60,
  fontSize: 14,
  padding: 12,
  paddingBottom: 4,
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  overflowY: 'auto',
  justifyContent: 'center',
  boxSizing: 'border-box',
  borderBottom: `1px solid ${appConfig.colors.bordersGray}`
};

export default {
  container: {
    margin: 0,
    padding: 0,
    overflowX: 'hidden'
  },
  inactive: {
    ...content,
    background: appConfig.colors.white
  },
  active: {
    ...content,
    backgroundColor: appConfig.colors.unreadNotification
  },
  itemTitle: {
    color: appConfig.colors.translucentBlack,
    textDecoration: 'none',
    whiteSpace: 'normal'
  },
  item: {
    textDecoration: 'none',
    display: 'flex'
  },
  firstItem: {
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5
  },
  lastItem: {
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5
  },
  unreadIndicator: {
    maxHeight: 7,
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 2.5
  },
  body: {
    whiteSpace: 'normal',
    marginBottom: 5
  }
};
